import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const StageCard = ({ stage, featured, onSelect, delay = 0 }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    className={`flex flex-col p-7 md:p-10 border ${featured ? 'bg-[#3d4f3c]/40 border-[#c8bfa8]/40' : 'bg-white/[0.03] border-white/20'}`}
    data-testid={`${stage.id}-card`}
  >
    <h3 className="text-white text-3xl md:text-4xl font-light">{stage.name}</h3>
    <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase mt-2 mb-8">{stage.stage}</p>

    <div className="flex items-baseline gap-4 mb-8">
      <p className="text-[#e3dcc6] text-4xl md:text-5xl font-light" data-testid={`${stage.id}-price`}>{stage.price}</p>
      <p className="text-white/70 text-sm">{stage.basis}</p>
    </div>

    <dl className="divide-y divide-white/15 border-y border-white/15 mb-8 flex-1" data-testid={`${stage.id}-inclusions`}>
      {stage.rows.map((r) => (
        <div key={r.item} className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-6 py-4">
          <dt className="text-white text-sm font-medium">{r.item}</dt>
          <dd className="sm:col-span-2 text-white/80 text-sm leading-relaxed">{r.detail}</dd>
        </div>
      ))}
    </dl>

    <p className="text-white/70 text-sm leading-relaxed mb-8">{stage.eligibility}</p>

    <button
      type="button"
      onClick={() => onSelect(stage.variant)}
      data-testid={`${stage.id}-cta`}
      className="group inline-flex items-center justify-center gap-3 bg-[#c8bfa8] text-[#1a1e1a] px-8 py-4 text-sm tracking-[0.12em] uppercase font-medium hover:bg-white transition-colors"
    >
      {stage.cta}
      <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
    </button>
  </motion.article>
);
